import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Controller, useFormContext } from "react-hook-form";

import { CardProps, StateProps } from "../../store";
import * as S from "./styles";

const MAX_FILE_SIZE_MB = 2;
const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024; // 10MB in bytes

const InputFile = ({ id }: Pick<CardProps, "id">) => {
  const { control } = useFormContext();

  const checkFileSize = (files: FileList | null) => {
    if (files) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < files.length; i++) {
        if (files[i].size > MAX_FILE_SIZE) {
          alert(`파일 크기는 ${MAX_FILE_SIZE_MB}MB를 초과할 수 없습니다.`);
          return false;
        }
      }
    }
    return true;
  };

  return (
    <Controller
      name={id}
      control={control}
      render={({ field: { onChange } }) => (
        <S.FileInput
          type="file"
          onChange={(e) => {
            if (checkFileSize(e.target.files)) {
              // Update local state for displaying file names
              onChange(e.target.files);
            } else {
              e.target.value = ""; // Clear the file input field
            }
          }}
          id="file-upload"
        />
      )}
    />
  );
};

export default InputFile;
